import React from 'react';

const AppModuleHeader = (props: any) => {
  const {
    placeholder,
    onKeyPress,
    onChange,
    onSearchClick,
    value,
    onClearText,
  } = props;

  return (
    <div className="gx-module-box-header-inner gx-d-flex gx-flex-row gx-justify-content-start gx-align-items-center gx-w-100 ">
      <span className="gx-search-icon gx-pointer gx-mx-1">
        <i onClick={onClearText} className="icon icon-close gx-text-grey" />
      </span>
      <input
        style={{ width: '80%' }}
        className="ant-input gx-border-0 gx-px-0 gx-pl-1 "
        type="search"
        placeholder={placeholder}
        onKeyPress={onKeyPress}
        onChange={onChange}
        value={value}
      />
      <span className="gx-search-icon gx-pointer">
        <i
          onClick={onSearchClick}
          className="icon icon-search-new gx-text-primary gx-mx-2"
        />
      </span>
    </div>
  );
};

export default AppModuleHeader;

AppModuleHeader.defaultProps = {
  styleName: '',
  value: '',
  notification: true,
  apps: true,
};
